import React from 'react';

const About = () => {
  return (
    <section id="about" style={{
      padding: '80px 40px',
      maxWidth: '1000px',
      margin: '0 auto',
      textAlign: 'center'
    }}>
      <h2 style={{ fontSize: '42px', marginBottom: '30px', color: '#333' }}>
        About Us
      </h2>
      <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#555', marginBottom: '20px' }}>
        Welcome to Southern Designs Store, where tradition meets craftsmanship. 
        Our handcrafted Andean alpaca sweaters and ponchos are made by skilled artisans 
        in the heart of South America.
      </p>
      <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#555', marginBottom: '20px' }}>
      At Southern Designs Store, tradition and modern design meet in the highlands of southern Ecuador. Our alpaca sweaters, ponchos, and accessories are hand-loomed by Andean artisans whose techniques have been passed down for generations.

We work exclusively with premium alpaca fiber—naturally soft, lightweight, and temperature-regulating, yet remarkably durable and hypoallergenic. From fiber selection and natural dyeing to hand-finishing, every step honors the land and the people who shape each piece.
      </p>
      <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#555' }}>
        When you purchase from us, you're not just buying a product – you're supporting 
        sustainable practices and helping preserve centuries-old craftsmanship. Our mission goes beyond beautiful textiles. We partner directly with artisan cooperatives, pay fair wages, and reinvest in training, safe workshops, and community projects. By choosing Southern Designs Store, you’re supporting sustainable grazing practices, small-batch production, and low-impact dyes that help protect Ecuador’s fragile mountain ecosystems.

Every garment tells a story—of skilled hands, quiet mountains, and the warmth of a living tradition. Wear something made with purpose, and help preserve the craft for the next generation. What sets us apart

Handcrafted in southern Ecuador by master weavers

Premium, ethically sourced alpaca fiber (soft, warm, hypoallergenic)

Fair pay, community reinvestment, and sustainable production

Small-batch quality with timeless Andean design
      </p>
    </section>
  );
};

export default About;
